'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  min-width: 400px;\n  @media(max-width: 450px) {\n    width: 100%;\n    min-width: 100%;\n  }\n'], ['\n  min-width: 400px;\n  @media(max-width: 450px) {\n    width: 100%;\n    min-width: 100%;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _buttonGroup = require('../button-group');

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _inputGroup = require('../input-group');

var _inputGroup2 = _interopRequireDefault(_inputGroup);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

/** @class CreateAccount
  * A React component ecapsulating creating new
  * email-based window.vexpo.firebase account
  */

var CreateAccount = function (_Component) {
  _inherits(CreateAccount, _Component);

  /** @constructor
    * Creates a new instance of the component
    */
  function CreateAccount(props) {
    _classCallCheck(this, CreateAccount);

    var _this = _possibleConstructorReturn(this, (CreateAccount.__proto__ || Object.getPrototypeOf(CreateAccount)).call(this, props));

    _this.state = { email: '', password: '', passwordConfirmation: '' };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleConfirmationChange = _this.handleConfirmationChange.bind(_this);
    _this.createUser = _this.createUser.bind(_this);
    return _this;
  }
  /** @function handleInputChange
    * Processes generic input change events
    */


  _createClass(CreateAccount, [{
    key: 'handleInputChange',
    value: function handleInputChange(event) {
      this.setState(_defineProperty({}, event.target.name, event.target.value));
    }
    /** @function handleConformationChange
      * Processes input changes for the password
      * confirmation field.
      */

  }, {
    key: 'handleConfirmationChange',
    value: function handleConfirmationChange(event) {
      if (event.target.value !== this.state.password) {
        this.setState({
          message: "Password and password confirmation do not match",
          passwordConfirmation: event.target.value
        });
      } else {
        this.setState({
          message: undefined,
          passwordConfirmation: event.target.value
        });
      }
    }
    /** @function createUser
      * Attempts to create a new window.vexpo.firebase email user with
      * the component's current state.
      */

  }, {
    key: 'createUser',
    value: function createUser() {
      var _this2 = this;

      window.vexpo.firebase.auth().createUserWithEmailAndPassword(this.state.email, this.state.password).catch(function (error) {
        // Handle Errors here.
        _this2.setState({ message: error.message });
      });
    }
    /** @function render
      * Renders the component
      */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(
          'h2',
          null,
          'New User'
        ),
        _react2.default.createElement(
          'div',
          { className: 'auth-message' },
          this.state.message
        ),
        _react2.default.createElement(
          _inputGroup2.default,
          null,
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_reactFontawesome2.default, { name: 'envelope' })
          ),
          _react2.default.createElement('input', { name: 'email',
            type: 'email',
            value: this.state.email,
            placeholder: 'email',
            onChange: this.handleInputChange
          })
        ),
        _react2.default.createElement(
          _inputGroup2.default,
          null,
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_reactFontawesome2.default, { name: 'key' })
          ),
          _react2.default.createElement('input', { name: 'password',
            type: 'password',
            value: this.state.password,
            placeholder: 'password',
            onChange: this.handleInputChange
          })
        ),
        _react2.default.createElement(
          _inputGroup2.default,
          null,
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_reactFontawesome2.default, { name: 'key' })
          ),
          _react2.default.createElement('input', { name: 'password-confirmation',
            type: 'password',
            value: this.state.passwordConfirmation,
            placeholder: 'password confirm',
            onChange: this.handleConfirmationChange
          })
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          _buttonGroup2.default,
          null,
          _react2.default.createElement(
            'button',
            { className: 'cancel', onClick: this.props.onCancel },
            _react2.default.createElement(_reactFontawesome2.default, { name: 'times' }),
            'Cancel'
          ),
          _react2.default.createElement(
            'button',
            { className: 'ok', onClick: this.createUser },
            _react2.default.createElement(_reactFontawesome2.default, { name: 'check' }),
            'Create'
          )
        )
      );
    }
  }]);

  return CreateAccount;
}(_react.Component);

exports.default = CreateAccount;


CreateAccount.propTypes = {};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/auth/email/email-registration.js
// module id = 905
// module chunks = 0